(function () {
  /*
   * Step 4-D: 下スクロールでヘッダーを隠す window.onscroll を撤去した。
   *
   * 撤去前は 300px を超えて下へスクロールすると
   * `navbar.style.top = '-11rem'` でヘッダーを画面外へ送り、上へ
   * スクロールすると '0' へ戻していた。③の確定仕様は「スクロール後も
   * ヘッダーが top 0 に残ること」なので、この挙動とは両立しない。
   *
   * 🔴 ここに戻さないこと。インライン style.top を書くコードが復活すると、
   *    CSS 側の top 指定を上書きしてヘッダーが隠れる。
   *
   * ドロップダウンのスクロール時自動クローズも一緒に無くなるが、
   * ヘッダーが常に同じ位置に留まるためドロップダウンも追従する
   * (絶対配置の親が fixed ヘッダー内にある)。画面外クリックで閉じる経路は
   * 下の documentElement クリックハンドラで維持している。
   */

  /*
   * Step 4-F: SP メニューの開閉をここで扱うのをやめた。
   *
   * 撤去前は #my-header-sidebar-open-button と
   * #my-mobile-sidebar-close-button に直接リスナーを張り、
   * #my-mobile-sidebar に .active を付け外ししていた。
   * SP カテゴリドロワーは共通外殻 my-drawer に移したので、開閉は
   * assets/my-drawer.js が data-drawer-open / data-drawer-close を見て行う。
   *
   * 🔴 ここで getElementById('my-mobile-sidebar-close-button') を
   *    参照し続けると、要素が無いので addEventListener が null 参照で
   *    TypeError を投げ、この IIFE 全体が止まる = 下のドロップダウンも
   *    動かなくなる。復活させないこと。
   */

  const productBtn = document.getElementById('productBtn');
  const productDropdown = document.getElementById('productDropdown');
  const productArrow = document.getElementById('productArrow');

  const toggleProduct = function () {
    productDropdown.classList.toggle('tw-opacity-0');
    productDropdown.classList.toggle('tw-opacity-90');
    var delayInMilliseconds = 300;
    if (productDropdown.classList.contains('tw-visible')) {
      setTimeout(function () {
        productDropdown.classList.toggle('tw-visible');
        productDropdown.classList.toggle('tw-invisible');
      }, delayInMilliseconds);
    } else {
      productDropdown.classList.toggle('tw-invisible');
      productDropdown.classList.toggle('tw-visible');
    }
    productDropdown.classList.toggle('show');
    productDropdown.classList.toggle('-tw-translate-y-4');
    productDropdown.classList.toggle('tw-translate-y-0');
    productArrow.classList.toggle('tw-rotate-0');
    productArrow.classList.toggle('tw-rotate-90');
  };

  productBtn.addEventListener('click', function (e) {
    if (topicsDropdown.classList.contains('tw-visible')) {
      toggleTopics();
    }
    e.stopPropagation();
    toggleProduct();
  });

  const topicsBtn = document.getElementById('topicsBtn');
  const topicsDropdown = document.getElementById('topicsDropdown');
  const topicsArrow = document.getElementById('topicsArrow');

  const toggleTopics = function () {
    topicsDropdown.classList.toggle('tw-opacity-0');
    topicsDropdown.classList.toggle('tw-opacity-90');
    var delayInMilliseconds = 300;
    if (topicsDropdown.classList.contains('tw-visible')) {
      setTimeout(function () {
        topicsDropdown.classList.toggle('tw-visible');
        topicsDropdown.classList.toggle('tw-invisible');
      }, delayInMilliseconds);
    } else {
      topicsDropdown.classList.toggle('tw-invisible');
      topicsDropdown.classList.toggle('tw-visible');
    }
    topicsDropdown.classList.toggle('show');
    topicsDropdown.classList.toggle('-tw-translate-y-4');
    topicsDropdown.classList.toggle('tw-translate-y-0');
    topicsArrow.classList.toggle('tw-rotate-0');
    topicsArrow.classList.toggle('tw-rotate-90');
  };

  topicsBtn.addEventListener('click', function (e) {
    if (productDropdown.classList.contains('tw-visible')) {
      toggleProduct();
    }
    e.stopPropagation();
    toggleTopics();
  });

  document.documentElement.addEventListener('click', function () {
    if (topicsDropdown.classList.contains('tw-visible')) {
      toggleTopics();
    }
    if (productDropdown.classList.contains('tw-visible')) {
      toggleProduct();
    }
  });
})();
